import { render } from "./pc_report_past.vue?vue&type=template&id=1fedab7c&scoped=true"
import script from "./pc_report_past.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_report_past.vue?vue&type=script&scoped=true&lang=js"

import "./pc_report_past.vue?vue&type=style&index=0&id=1fedab7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fedab7c"]])

export default __exports__